import { useTranslation } from 'react-i18next'

import { LightningIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import Statistic from '@/common/components/Statistic/Statistic'
import { viewIds } from '@/returns/pages/TransactionsPage/constants'

const CurrentMonthInstantTransactions = ({ transactions, onClick }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      Icon={LightningIcon}
      label={t('Instantáneas')}
      value={<AnimatedNumber target={transactions} format="percent" />}
      onClick={() => onClick(viewIds.lastThirtyDaysInstant)}
    />
  )
}

export default CurrentMonthInstantTransactions
